exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pp-mobile-cover-art-slider{width:100%;height:300px;overflow-x:scroll;display:flex;flex-wrap:nowrap;align-items:center}.pp-mobile-cover-art-slider__slide{flex-shrink:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center}.pp-mobile-cover-art-slider__slide img{max-width:100%;max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-541b2231","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MobileCoverArtSlider.vue
// module id = 163
// module chunks = 0